<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" @close="close">
    <el-radio-group v-model="radio">
      <el-radio :label="1" style="margin-bottom: 15px">
        直接改价格：
        <AmountDigitInput v-model="approvalAfterPrice" append="元" style="width: 150px"/>
      </el-radio>
      <el-radio :label="2" :disabled="isDisabledCact">
        按公式修改：当前价格 X
        <el-input-digit v-model.number="formula.percentage" :disabled="isDisabledCact" format="+#.###" style="width: 70px">
          <span>%</span>
        </el-input-digit>
        +
        <AmountDigitInput v-model="formula.plus" :disabled="isDisabledCact" append="元" style="width: 90px"/>
        -
        <AmountDigitInput v-model="formula.reduce" :disabled="isDisabledCact" append="元" style="width: 90px"/>
      </el-radio>
    </el-radio-group>
    <!-- <p style="color: #aaa; font-size: 12px">（小数点后3位四舍五入）</p> -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>

    <el-dialog title="提示" :visible.sync="tipDialogVisible" width="400px">
      <div class="el-message-box__content">
        <div class="el-message-box__status el-icon-warning"></div>
        <div class="el-message-box__message">{{ tipText }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="isOver">
          <el-button @click="cancelEdit">放弃改价</el-button>
          <el-button @click="tipDialogVisible = false">重新改价</el-button>
          <el-button type="primary" @click="submitCheck">提交改价审核</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="tipDialogVisible = false">好的</el-button>
        </template>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { changePriceApprovalRecord, getPurchaseConfig } from '@servers/dangkou/index.js';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      radio: 1,
      approvalAfterPrice: '',
      formula: {
        percentage: 100,
        plus: '',
        reduce: '',
      },
      distributorCompanyId: '',
      rows: [],
      title: '改供货价',
      isDisabledCact: false,
      dialogVisible: false,
      tipDialogVisible: false,
      tipText: '',
      isOver: false,
      successFn: null,
    };
  },
  computed: {
    ...mapGetters(['amountDigit']),
  },
  methods: {
    openDialog(rows, { title, distributorCompanyId, successFn }) {
      this.distributorCompanyId = distributorCompanyId;
      this.rows = rows || [];
      this.title = title || this.title;
      this.successFn = successFn;
      this.isDisabledCact = rows.some(item => Array.from(new Set(item.purchasePriceList || [])).length !== 1);
      this.dialogVisible = true;
    },
    close() {
      // 清空数据
      this.dialogVisible = false;
      this.approvalAfterPrice = '';
      this.formula = {
        percentage: 100,
        plus: '',
        reduce: '',
      };
      this.radio = 1;
    },
    async sure() {
      const checkRes = await this.saveBeforeCheck();
      if (!checkRes) return;
      this.save();
    },
    async save() {
      const priceChangeApprovalRecordList = this.rows.map(item => {
        let approvalAfterPrice = this.approvalAfterPrice;
        if (this.radio == 2) {
          const oldPrice = ((item.purchasePrice || item.purchasePriceList[0] || 0) / 100).toFixed(this.amountDigit);
          approvalAfterPrice = oldPrice * (this.formula.percentage / 100  || 0) + (this.formula.plus || 0) - (this.formula.reduce || 0);
        }
        return {
          purchaseOrderIdList: item.purchaseOrderIds,
          sourceType: 3, // 单据来源  0：app、1：小程序、2：PDA、3：快麦通
          supplierId: item.supplierCompanyId, // 供应商ID
          sysItemId: item.sysItemId,
          sysSkuId: item.sysSkuId,
          approvalAfterPrice: approvalAfterPrice.toFixed(this.amountDigit), // 改价价格
        };
      });

      const params = {
        distributorCompanyId: this.distributorCompanyId,
        priceChangeApprovalRecordList,
      };
      const res = await changePriceApprovalRecord(params);
      if (res) {
        this.tipDialogVisible = false;
        this.close();
        this.$message.success(`提交改价申请成功`);
        this.successFn && this.successFn();
      }
    },
    async saveBeforeCheck() {
      const approvalAfterPrice = this.approvalAfterPrice;
      if ((this.radio == 2 && !this.formula.percentage) || (this.radio == 1 && !approvalAfterPrice)) {
        this.$message.error(`请填写价格`);
        return false;
      }
      const config = await getPurchaseConfig({ companyId: this.distributorCompanyId });
      // 自动校验采购商是否开通“允许修改供货价”
      const { openUpdateDeliveryPrice, approvalType, approvalExcessCount } = config.priceChangeApprovalConfig || {};

      if (openUpdateDeliveryPrice) {
        // 校验所改价格是否超过采购商限定额度
        if (approvalType == 1) {
          this.isOver = this.rows.some(row => {
            const oldPrice = ((row.purchasePrice || row.purchasePriceList[0] || 0) / 100).toFixed(this.amountDigit);
            let diffPrice = 0;
            if (this.radio == 1) {
              diffPrice = approvalAfterPrice - oldPrice;
            } else {
              let price = oldPrice * (this.formula.percentage / 100 || 0) + (this.formula.plus || 0) - (this.formula.reduce || 0);
              diffPrice = price - oldPrice;
            }
            return Math.abs(diffPrice) > approvalExcessCount;
          });

          if (this.isOver) {
            this.tipDialogVisible = true;
            this.tipText = `您修改的供货价超过采购用户限定额度，需联系采购用户审核改价结果`;
            return false;
          }
        }
      } else {
        this.close();
        this.tipDialogVisible = true;
        this.tipText = `采购用户未开通拿货改价，您无法修改价格。请联系采购用户开通，建议开通后尝试`;
        return false;
      }
      return true;
    },
    submitCheck() {
      this.save();
    },
    cancelEdit() {
      this.tipDialogVisible = false;
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
